import {
  PEER_REVIEWER_REQUEST_CONFLICT,
  PEER_REVIEWER_RESPONSE_CONFLICT,
  PEER_REVIEWER_FAILURE_CONFLICT,
  PEER_REVIEWER_KEYWORD_REQUEST,
  PEER_REVIEWER_UPDATE_TITLE,
  PEER_REVIEWER_UPDATE_ABSTRACT,
  PEER_REVIEWER_UPDATE_APPLICANT
} from "../../actions/types";

const initialState = {
  isFetching: false,
  results: [],
  affi_match: [],
  selectedPairs: [],
  tree: {},
  error: false
};

const setRequest = (state, action) => {
  return {
    ...state,
    isFetching: true,
    error: false,
    results: [],
    affi_match: [],
    selectedPairs: [],
    tree: {}
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    affi_match: [],
    selectedPairs: [],
    tree: {}
  };
};

const setUpdate = (state, action) => {
  return {
    isFetching: false,
    results: [],
    affi_match: [],
    selectedPairs: [],
    tree: {},
    error: false
  };
};

const setResponse = (state, action) => {
  let { infos } = action.payload || {};
  infos = infos || {};
  let { internal_kol, target_kol } = infos;
  let results = action.payload.results.article_match || [];
  let selectedPairs = [];
  let affiMatch = action.payload.results.affi_match || [];
  if (results.length > 0) {
    selectedPairs = results[0].pairs;
  }

  target_kol = target_kol || [];
  internal_kol = internal_kol || [];

  const tree = {};
  for (let i of [...internal_kol, ...target_kol]) {
    tree[i.expertId || i.id || i.key] = i;
  }

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    selectedPairs,
    affiMatch,
    tree: tree
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PEER_REVIEWER_RESPONSE_CONFLICT:
      return setResponse(state, action);
      break;

    case PEER_REVIEWER_FAILURE_CONFLICT:
      return setFailure(state, action);
      break;

    case PEER_REVIEWER_REQUEST_CONFLICT:
      return setRequest(state, action);

    case PEER_REVIEWER_KEYWORD_REQUEST:
      return setUpdate(state, action);

    case PEER_REVIEWER_UPDATE_ABSTRACT:
      return setUpdate(state, action);

    case PEER_REVIEWER_UPDATE_TITLE:
      return setUpdate(state, action);

    case PEER_REVIEWER_UPDATE_APPLICANT:
      return setUpdate(state, action);

    default:
      return state;
      break;
  }
};
